import {DIALOG_OPEN_DATA_ATTRIBUTE} from '../design-system/organisms/Dialog/constants';

export const checkIfDialogVisible = () => {
  return window.document.body.hasAttribute(DIALOG_OPEN_DATA_ATTRIBUTE);
};
